import { mediaApi } from '../../api/media'
import { useUiStore } from '../../stores/uiStore'

interface Props {
  ids: string[]
}

export function MediaAlbum({ ids }: Props) {
  const { openMedia } = useUiStore()
  const count = ids.length

  const gridClass =
    count === 1 ? 'grid-cols-1' :
    count === 2 ? 'grid-cols-2' :
    count === 3 ? 'grid-cols-3' :
    count === 4 ? 'grid-cols-2' :
    'grid-cols-3'

  return (
    <div className={`grid gap-0.5 rounded-lg overflow-hidden max-w-[280px] ${gridClass}`}>
      {ids.slice(0, 9).map((id, i) => {
        const isLast = i === 8 && ids.length > 9
        return (
          <button
            key={id}
            onClick={() => openMedia(mediaApi.getURL(id))}
            className="relative aspect-square overflow-hidden bg-bg-input"
          >
            <img
              src={mediaApi.getThumbnailURL(id, '800x800')}
              alt="media"
              className="w-full h-full object-cover"
              loading="lazy"
              onError={(e) => { e.currentTarget.style.display = 'none' }}
            />
            {isLast && (
              <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
                <span className="text-white text-xl font-bold">+{ids.length - 9}</span>
              </div>
            )}
          </button>
        )
      })}
    </div>
  )
}
